<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{travelIcon}}</v-icon>
          Travel Summary
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-md-and-down">
          <v-btn flat @click="printCertificate" v-if="canPrintCertificate" :loading="printCertificateLoading">
            Print Certificate
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <v-btn flat @click="showComm = true">
            Communication
            <v-icon right>mdi-comment-text</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-btn icon class="hidden-lg-and-up">
          <v-menu bottom left>
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="printCertificate" v-if="canPrintCertificate">
                <v-list-tile-title>Print Certificate</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showComm = true">
                <v-list-tile-title>Communication</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Quotation No.</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span class="title">{{commonForm.proposalNo}}</span>
                  </v-flex>
                  <template v-if="commonInfo.premium.premiumPayable">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Premium Payable</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
                    </v-flex>
                  </template>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Current Status</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span :class="currentStatusClass">{{currentStatusLabel}} </span>
                    <span v-if="quotation.commonInfo.paid"> - Paid</span>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Intermediary</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span>{{commonForm.intermediary}} - {{queryInfo.intermediary}}</span>
                  </v-flex>
                  <template v-if="commonForm.product">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Product</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.product}} - {{queryInfo.product}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.tripType">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Trip Type</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{tripType}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.travelArea">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Geographical Area</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{queryInfo.travelArea}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.noAdult !== null">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">No. of Adult(s)</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{travelForm.noAdult}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.noChild !== null">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">No. of Child(ren)</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{travelForm.noChild}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.planNo">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Plan</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{queryInfo.plan}}</span>
                    </v-flex>
                  </template>
                  <template v-if="travelForm.travelType">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Travel Type</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{travelType}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.acceptDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.startDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Start Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDate(commonForm.startDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.endDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">End Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDate(commonForm.endDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="queryInfo.discLdg && queryInfo.discLdg.length > 0">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Loadings</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <ul>
                        <li v-for="discLdg in queryInfo.discLdg" :key="discLdg.discLdg">
                          {{discLdg.discLdgDesc}}
                        </li>
                      </ul>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.campaign">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Campaign</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.campaign}} - {{queryInfo.campaign}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.promotion">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Promotion</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.promotion}} - {{queryInfo.promotion}}</span>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showComm" width="600px">
      <comms-log :canSendSMS="checkAccess(['travelQuoteIFSMS'])" :canSendEmail="checkAccess(['travelQuoteIFMail'])" @close="showComm = false"></comms-log>
    </v-dialog>
  </div>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import { travelType, tripType } from '@/const/underwriting/travel'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import CommsLog from '../../shared/CommsLog'

export default {
  data() {
    return {
      printCertificateLoading: false,
      showComm: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    currentStatusClass() {
      if (this.quotation.commonInfo.statusCode === 'QD' || this.quotation.commonInfo.statusCode === 'PD' || this.quotation.commonInfo.statusCode === 'VO' || this.quotation.commonInfo.statusCode === 'NTU' || this.quotation.commonInfo.statusCode === 'CL') {
        return 'error--text'
      } else if (this.quotation.commonInfo.statusCode === 'QPA' || this.quotation.commonInfo.statusCode === 'PPA') {
        return 'warning--text'
      } else if (this.quotation.commonInfo.statusCode === 'IF' || this.quotation.commonInfo.statusCode === 'PO') {
        return 'success--text'
      } else {
        return ''
      }
    },
    travelForm() {
      return this.quotation.travelForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    queryInfo() {
      return this.quotation.queryInfo
    },
    travelIcon() {
      return appIcon.TRAVEL
    },
    travelType() {
      return travelType[this.travelForm.travelType]
    },
    tripType() {
      return tripType[this.travelForm.tripType]
    },
    canPrintCertificate() {
      if (this.checkAccess(['travelPrintCertificate'])) {
        if (this.$store.state.agency.quotationSettings.menu.printCertificate) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  methods: {
    async printCertificate() {
      const apiUrl = this.$store.state.agency.quotationSettings.menu.printCertificate
      if (apiUrl) {
        try {
          this.printCertificateLoading = true
          const passObj = {
            proposalNo: this.commonForm.proposalNo,
            certType: 'F'
          }
          await this.$http.post(apiUrl, passObj)
          this.printCertificateLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.printCertificateLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  mounted() {
    // If Query param (if) is passed in, its coming from Inforced Proposal
    // Check comms log
    if (this.$route.query.if) {
      if (this.checkAccess(['travelQuoteIFSMS']) || this.checkAccess(['travelQuoteIFMail'])) {
        this.showComm = true
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    CommsLog
  }
}
</script>

<style lang="scss">
</style>
